export function isNonEmptyString(v) {
  return typeof v === 'string' && v.trim().length > 0;
}

export function validateEmail(email) {
  if (!isNonEmptyString(email)) return false;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
}

export function normalizePhone(phone) {
  if (!isNonEmptyString(phone)) return '';
  return phone.replace(/[^0-9+]/g, '');
}

export function validatePhone(phone) {
  const p = normalizePhone(phone);
  if (!p) return false;
  return /^\+?[0-9]{7,15}$/.test(p);
}
